// Экран, которого ещё нет.
//
// Заглушка называет задачу, которая его сделает. Так каркас можно пройти
// целиком и увидеть, что навигация работает, не делая вид, что экран готов:
// пустая страница без объяснения выглядит поломкой, а не незавершённостью.

export function Placeholder({ title, issue, note }: { title: string; issue: string; note?: string }) {
  return (
    <>
      <div className="feed-header">{title}</div>
      <div className="content">
        <p className="muted">{note ?? 'Экран будет собран отдельной задачей.'}</p>
        <p className="caps">{issue}</p>
      </div>
    </>
  )
}
